import React from "react"
import { DatePicker as MuiDatePicker, DatePickerProps } from "@mui/x-date-pickers"
import Label from "../label"
import Stack from "../stack"

interface CustomDatePickerProps extends Omit<DatePickerProps<any>, "renderInput"> {
  label?: string
  required?: boolean
  placeholder?: string
  size?: "small" | "medium"
  helperText?: string
  error?: boolean
  maxWidth?: string
  labelMb?: number
  disabledInput?: boolean
}

const DatePicker: React.FC<CustomDatePickerProps> = ({
  label,
  required,
  placeholder,
  size = "small",
  helperText,
  error,
  maxWidth,
  labelMb,
  disabledInput,
  ...props
}) => {
  return (
    <Stack sx={{ width: "100%", maxWidth }}>
      {label && <Label mb={labelMb} labelColor={error ? "error" : undefined} label={label} required={required} />}
      <MuiDatePicker
        {...props}
        slotProps={{
          textField: { required, placeholder, size, helperText, error, disabled: disabledInput },
          ...props.slotProps
        }}
      />
    </Stack>
  )
}

export default DatePicker
